module.exports = __webpack_public_path__ + "img/flcb_fightlandtkn.21e3e59.png";